import AuthenticatedResource from 'resources/AuthenticatedResource'

export default class StudentResource extends AuthenticatedResource {
  static urlRoot = '/courses/:course_id/students' as const;

  readonly id: number | undefined = undefined;
  readonly first_name: string = '';
  readonly last_name: string = '';
  readonly email: string = '';
  readonly wallet_address: string = '';
  readonly rewards_count: number = 0;
  readonly points: number = 0;


  pk() {
    return this.id?.toString();
  }
}
